import { FormFieldHeaderColumn } from './form-field-header-column';
import { Filter } from '../filters/filter';

export class FormFieldHeader {
  id: string;
  templateId: string;
  kind: string;
  columns: FormFieldHeaderColumn[];
  filter: Filter;
  static: boolean;
  description: string;

  constructor(item) {
    this.id = item.id;
    this.templateId = item.templateId;
    this.kind = item.kind;
    this.static = !!item.static;
    this.description = item.description;

    // the default behavior is to create a single generic column
    this.columns = [new FormFieldHeaderColumn(item)];
  }
}
